import React from "react";
import Image from "next/image"
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "../../../../services/ServicesSections.module.scss";

// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
      <a className={classes.anchor} id="start"></a>

      
      <div style={{textAlign: "center",maxWidth:"431px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width = {431}
                      height = {324}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/1-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />The expectant masses...</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title}>Feb 2022 comment:</h3>
            <p>
              <br />
              Its funny looking back how PII (Personally identifiable information) really dominated a lot of the talks on this day. This was 2017, fully 4 + years ago. I really do feel like the wheels of change move slowly in so many ways. Part of the problem I believe is we are all so linked to the titans of modern digital data: google and FB. PII is their business model... and we all rely on them so much. See Christopher Wylie's public statements on making these companies public utilities for ways in which to handle this situation.
              <br /><br />
              ——————————————————————–
              Time: Early-ish.. Arrived early to help setup and get the Tribalism swag table ready. We went with a number of “Make Analytics Great Again” battery chargers and stickers as well as a few case studies of our work. The chargers were pretty popular and all got snapped up by the end of the day. What do you think?
          </p>

        </GridItem>
          

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Measurecamp Sydney 2017 - Review</h3>
          <p>  
            <br />
            For those who don’t know, <a href="http://sydney.measurecamp.org/">Measurecamp</a> is basically a “Choose your own Adventure” with the added bonus that you are also an active participant. Here is a run down of my day, as a sponsor, an organiser, but most importantly a fan. Everyones is different, so this is just what I saw. Enjoy!
            <br /><br />
            ——————————————————————–
            Time: Early-ish.. Arrived early to help setup and get the Tribalism swag table ready. We went with a number of “Make Analytics Great Again” battery chargers and stickers as well as a few case studies of our work. The chargers were pretty popular and all got snapped up by the end of the day. What do you think?
          </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"800px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {770}
                      height = {577.5}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/2-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Make Analytics Great Again!</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
            <br />
            <strong>9.30am Moe’s Intro</strong> Some people were hitting caffeine overload (or in my case underload) when Moe hit the stage. She did a really great job setting up the day for everyone. Moe is very good at welcoming new people and getting everyone excited for things.          
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"800px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {770}
                      height = {577.5}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/3-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Moe introducing the day</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
            <br />
            <strong>10am First talk – ME!</strong>  In the big room! Luckily Tribalism had randomly scored the rights to sponsor the big room, so I had to go there! Seeing as not many people wanted to go first I went with it, first up for the second year in a row… this time I was going more technical – it was on <strong>GCP + Tensorflow + Datalab: Adopting Kazunori Sato’s Manhattan code to Victorian Car Crash Data.</strong> Using the command line interface I wanted to show how easy it is to interact with GCP and build machine learning models in Cloud Datalab. Im not sure how successful I was, I suspect a lot went over people’s heads and time was an enemy. Thats the thing with the cloud platform. Yes each of the individual tools are awesome and easy to use, but the time adds up when using all of them back to back. Regardless, I hope the attendees got to see how accessible Machine Learning is right now and that they should dive right in. Automation and machine learning is 100% where we are going as a business 🙂
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"640px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {640}
                      height = {480}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/4.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Randomly scribbling on the main wall</i></p>
                    
            </GridItem>
          </div>


        <div style={{textAlign: "center",maxWidth:"770px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {770}
                      height = {577.5}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/5-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />My talk: GCP, Tensorflow, Datalab, Colours and Melbourne</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
            <br />
            <strong>10.30am </strong>  Next up was Lucas Lee making his Measurecamp debut. Lucas is a good speaker. He spoke about hacks and time savers around Google Analytics, Data Studio and LinkedIn. Good talk Lucas!
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"640px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {640}
                      height = {480}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/6.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Lucas Lee on GA and Datalab hacks</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
            <br />
            <strong>11am </strong>   Damion Brown from Data Runs deep. Little was I to know that I would see Damion speak 3 times today! I definitely won the fan-boy award and in the last “talk” he was good enough to give me a signed copy of The Grateful Dead’s American Beauty* (*may or may not be true). This first talk was on <strong>PII (Personally Identifiable Information) for a White Guy.</strong> It was so controversial that Ash Rane from Google had to be called in to mediate. Needless to say everyone left the room even more confused about PII than ever, which, after I asked Damion at the end, I found out was his intention all along. Well played!
            </p>

        </GridItem>
        <div style={{textAlign: "center",maxWidth:"640px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {640}
                      height = {480}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/7.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Damion Brown from Data Runs Deep</i></p>
                    
            </GridItem>
          </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            <br />
            <strong>11.15am </strong>    After a short break I saw Chaoming Li’s talk on his <strong>new product Insightech</strong> <a href="https://www.insightech.com/">link</a>, which is essentially an alternative to tag based analytics systems like Google Analytics. It essentially captures every website interaction which you can replay like a video.. I’ve seen this product a number of times already and I’m really excited about it. I’m hoping to partner with Chaoming for some pilots with some of our clients – if you are interested in such a collaboration drop me a bell! Great talk Chaoming!
            </p>
            <p><strong>11.45am</strong> – I started watching Moe Kiss’s talk on <strong>Why Analysts should get out of Analytics Tools</strong>, but it was heaving and I wanted to divert some time for Damion Brown’s <strong>Build your Freelance Empire</strong> talk.. So it was over to the Data Runs Deep room again. This was a really great talk for someone like me running my own business. Damion has established a great business in Data Runs Deep. He had some awesome tidbits that I will utilise in my day to day. I hope I didn’t take over with too many questions Damion, but I was into this talk! 🙂</p>
            <p><strong>12.15pm</strong> I was asked by Runze Xu to come to a <strong>machine learning ‘brainstorm’ session</strong> – maybe because of my talk earlier. This ended up being a really interactive whiteboard session about how to measure and classify website journeys in terms of conversion. My main take-outs where: I think it’s pretty hard to distinguish users based on website activity alone. For this to be really useful you need CRM or other external data. Still good session and thanks to all the participants involved.</p>

            <p><strong>12.15pm-2pmish</strong> During a scrumptious lunch I caught up with Jack Golding from White Pages. He’d loosely agreed previously in the Measure Slack group to do his <strong>GAIQ exam live on stage with me</strong>. Jack v Scott, no study, in less than a 30 mins session (time allowed for exam 90mins). As no one was in the main auditorium, I set up the double screens in preparation for 2.30…</p>

            <p><strong>2.30pm</strong> – <em>a half hour that will go down in infamy…</em> or others will say it wasn’t really a big deal whats all the fuss about(?), went down at 2.30pm. <strong>GAIQ exam live on stage, Scott v Jack.</strong> For a bit of context we’d both normally breeze this exam, but in the cauldron of the Measurecamp Tribalism room we were in for a shock. I was on the creaky old university desktop (left screen as you look at it). Jack had his trusty laptop and no power. Things were off to a good start, we’d already wasted 2 minutes and a minuscule crowd of hecklers were already getting stuck in to us. Angus Beattie from Google left the room in disgust at our collective ineptitude. He left a sarcastic “Good luck”, I think. Thanks Angus! 🙂 There were 70 questions and I can’t remember any of them. The pressure on stage was unbelievable, my eyeballs were looking at the screen but nothing was going into my brain. More than once did I get stuck on the dreaded “these are both right!” conundrum, followed by “helpful” arguments in the auditorium. It was a mixture of help and sledging from the crowd throughout. Sam Redfern and Mike Robins in particular were really getting into it. “Thanks” guys. A crowd was starting to build, word had gotten out… With sweat pouring down my brow, and channeling my inner Cathy Freeman, I was on the final straight – 5 questions slower than Jack with 3 mins to go and he was waiting on the last question :-/. The last 5 were easy and so we hit the “Submit” button at the same time, 1 minute to go. YES!!! We both passed. 85% to me, 80% to Jack (both just scraped the 80% pass mark hahaha). Joyous scenes in the auditorium, strangers hugged and kissed, a “we love analytics” chant started……</p>

            <p>That’s not quite true. We were hurriedly/angrily escorted out so that the next speaker could present as we were right on the time limit. But we didn’t care, wed done it. We saved our jubilation for the breakout area. <em>What a time to be alive!!!</em></p>

            <p><strong>3.00pm</strong> I went to see Greg Mulligan’s from Amiphex talk <strong>Programmatic Trading</strong>. One of the great things about Measurecamp is to experience different material from other parts of the industry less close to your own. I’ve collaborated with Greg on some projects recently where I needed his expertise and can testify to his indepth knowledge of the Programmatic scene. The biggest takeout here for me was that looking for 100% viewability is essentially an illusion and it is more efficient to bid on lower viewability levels. Great talk Greg!</p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"640px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width  = {640}
                      height = {480}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/8.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><i><br />Greg Mulligan from amiphex, who we sometimes work with, on programmatic Trading</i></p>
                    
            </GridItem>
          </div>

                  <GridItem xs={12} sm={8} md={8}>
                  <p><strong>4.00pm</strong> After a way too long afternoon break 🙂 it was time for Damion Brown again. <strong>The Album that Changed Your Life</strong>. Not sure what I was expecting here, but there was literally no data / analytics talk at all. We went around the room talking about the albums that changed our lives. I came up with Offspring – Smash, Nirvana – Unplugged and Faith No More – King For a Day. What can you say – we talked about albums, it was good. To be honest Id argue that Spotify has changed my life more than any album, but hey. Then we got unceremoniously kicked out of the room.</p>


        </GridItem>

        <div style={{textAlign: "center",maxWidth:"480px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12} lg = {12}> 
            <div >
            <Image
                      quality = {100}
                      layout = "responsive"
                      objectFit = "none"
                      width  = {480}
                      height = {640}
                      src="/img/posts/2017-11-07-measurecamp-sydney-2017-review/9.webp"
                      alt="..."
                      
                    />
            </div>
                    
                    <p><i><br />Contemplating the late arvo sessions… This is not a pose! I swear I was not posing for this photo!</i></p>
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p><strong>4.30pm</strong> This was a panel of sorts: <strong>Analytics Attacks!</strong> hosted by Mike Robbins including Sam Redfern, Ash Rane and Jack Golding. A few interesting propositions were discussed including forcefully sending PII information to a competitor’s GA account via the measurement protocol. Sit back and wait for Google to shut down their analytics account. Ingenious! But why? It does make you think though… analytics tools in general are pretty vulnerable to corruption (spam traffic a case in point).</p>

          <p>And that was it… I got to do the wrap up and bring the organisers got up on stage. After that it was off to the pub for some well earned beverages and food. Another great Measurecamp Sydney was had by all.</p>

          <p><strong>Major thanks to the organisers/volunteers:</strong> Moe Kiss, Simon Rumble, Sam Redfern, Michelle McGrath, Chaoming Li, Priscilla Cheung, Jethro Nederhoff, Amanda Elliott, Rod Jacka, Mike Robins and Ash Rane. Fingers crossed I didn’t miss anyone!</p>

          <p><strong>Also to the Sponsors:</strong> <a href="https://www.snowflake-analytics.com/">Snowflake Analytics</a>, <a href="https://datarunsdeep.com.au/">Data Runs Deep</a>, <a href="https://datatrue.com/">Datatrue</a>, <a href="http://www.tribalism.com.au/">Tribalism</a>, <a href="https://www.keboola.com/">Keboola</a>, <a href="https://billigence.com/">Billigence</a>, <a href="https://www.google.com.au/analytics/360-suite/">Google Analytics 360</a>, <a href="https://www.domo.com/">Domo</a></p>



        </GridItem>





      </GridContainer>
    </div>

  );
}
